// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XxDlI","title":"styles_title__27Gt8"};